export const cancelOrderTitle = 'Are you sure you want to create Cancel Request for the selected order?';
export const cancelOrderDiscoTitle = 'Are you sure you want to create Cancel/Disco Request for the selected order?';
export const declineRenewalTitle = 'Are you sure you want to decline renewal for the selected order?';
export const reasonCancel = 'Cancellation reason';
export const reasonDecline = 'Reason for decline';
